import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faFighterJet } from "@fortawesome/free-solid-svg-icons";
import useScreenWidth from 'app/hooks/useScreenWidth';
import * as commonActions from 'app/actions/commons';
import Image from 'app/components/layouts/Image';
import { getNewSlug } from "app/requests/blogs";
import languages from 'app/data/languages.json';
import { useTranslation } from 'next-i18next';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from "next/router";
import storage from 'app/utils/storage';
import env from '.env.json';

const LanguageDropdown = () => {
  const [visibleMenu, setVisibleMenu] = useState(true);
  const [language, setLanguage] = useState(env.DEFAULT_LOCALE);
  const screenWidth = useScreenWidth();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    const languageLocal = router.locale || env.DEFAULT_LOCALE;
    setLanguage(languageLocal);
    updateLanguageSystem(languageLocal);
  }, []);

  const updateLanguageSystem = (value: string) => {
    storage.set("language", value)
    if (Object.keys(i18n).length) {
      i18n.changeLanguage(value);
    }
  }

  const getRoute = async (new_code: string) => {
    const routes = ['/grammar/', '/news/'];

    const route = routes.find((item: string) => {
      return router.asPath?.includes(item);
    })

    if (route) {
      dispatch(commonActions.setLoading(true));

      const result = await getNewSlug({
        slug: router?.query?.slug as string,
        code: router.locale,
        new_code,
      });

      dispatch(commonActions.setLoading(false));
      return result[`slug_${new_code}`] ? `${route}${result[`slug_${new_code}`]}` : undefined;
    }

    if (router.asPath?.includes('/vocabularies/') && !router.asPath?.includes('/topics')) {
      if (new_code == 'vi') {
        return router.asPath?.replace('-meaning-pronunciation-usage', '-la-gi-phat-am-cach-dung');
      }

      return router.asPath?.replace('-la-gi-phat-am-cach-dung', '-meaning-pronunciation-usage');
    }

    return undefined;
  }

  const handleRedirectDomain = (value: string, path: string) => {
    const isVi = env.DEFAULT_LOCALE === 'vi';
    const isEn = env.DEFAULT_LOCALE === 'en';

    if (
      (isVi && value === 'en' && env.OTHER_DOMAIN) ||
      (isEn && value === 'vi' && env.OTHER_DOMAIN)
    ) {
      window.location.href = `${env.OTHER_DOMAIN}/${path}`;
    } else {
      window.location.href = `${env.OTHER_DOMAIN || env.ROOT_URL}/${value}/${path}`;
    }
  };

  const changeLanguage = async (value: string) => {
    const path = await getRoute(value) || router?.asPath;
    handleRedirectDomain(value, path);
  }

  return (
    <>
      <div
        className="nav-link py-2 text-white font-weight-bold text-size-md"
      >
        <Image
          width={40}
          height={40}
          disableAuto
          alt={language}
          onClick={() => setVisibleMenu(true)}
          src={`/images/languages/${language}.webp`}
        />
      </div>
      {(visibleMenu || screenWidth > 1100) &&
        <ul className="dropdown-menu dropdown-menu-language" style={{ minWidth: 230 }}>
          {
            languages
              .filter((language) => language.code !== router.locale)
              .map((language, index: number) => {
              return (
                <li className='item-menu cursor-pointer' key={index}>
                  <span
                    onClick={() => changeLanguage(language.code)}
                    className="nav-link p-2 font-weight-bold cursor-pointer text-size-md d-flex"
                  >
                    <Image
                      width={30}
                      height={30}
                      className="mr-3"
                      disableAuto
                      alt={language.label}
                      src={`/images/languages/${language.code}.webp`}
                    />
                    <div className="d-inline route-name">
                      {language.label}
                    </div>
                    <div className="box-icon-redirect">
                      <FontAwesomeIcon className="icon-redirect" icon={faFighterJet} />
                    </div>
                  </span>
                </li>
              )
            })
          }
        </ul>
      }
    </>
  )
}

export default LanguageDropdown;
